import React, { useEffect, useState } from "react";
import { Steps, Button, Form, Upload, Modal } from "antd";
import { PictureOutlined, UploadOutlined } from "@ant-design/icons";
import * as Yup from "yup";
import { useFormik } from "formik";
// import { addBusiness, updateDeveloper, getAllSector, addSector } from "../services/developerApi";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Spin } from "antd";
// import FormField from '../../../../common/Form/FormField';
// import '../utils/style.css';
// import { Col, Row } from "reactstrap";
// import RecapForm from "./recapForm";
// import PaymentMethodSelector from "./PaymentMethodSelector";
// import countryList from "react-select-country-list";
// import SelectField from "../../../../common/Form/SelectField";
// import CreatableSelectField from "../../../../common/Form/CreatableSelect";
// import { deleteMedia, uploadImage } from "../../../media/services/mediaApi";

const { Step } = Steps;

const AddEditDevForm = ({ modal, setModal, toggle, selectedDeveloper, currentuser }) => {
  // const [currentStep, setCurrentStep] = useState(0);
  // const [form] = Form.useForm();
  // const queryClient = useQueryClient();
  // const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  // const [logoFile, setLogoFile] = useState(null);
  // const [registryFile, setRegistryFile] = useState(null);
  // const [imageUrl, setImageUrl] = useState(null);
  // const merchandId = currentuser?.user?.id || currentuser?.userId;

  // const countries = countryList().getData();
  // const { data: sectors, isLoading: isLoadSect, isError: isErrorSect, error: errorSect } = useQuery("sectors", getAllSector);

  // const validationSchema = Yup.object().shape({
  //   businessName: Yup.string().required("Oups!!! Veuillez renseigner le nom"),
  //   description: Yup.string().required("Merci de renseigner la description"),
  //   countryPaymentMethods: Yup.array().min(1, "Sélectionnez au moins une méthode de paiement"),
  // });

  // const initialValues = selectedDeveloper ? {
  //   logo: selectedDeveloper.logo,
  //   businessRegistry: selectedDeveloper.businessRegistry,
  //   businessName: selectedDeveloper.businessName,
  //   ipnUrl: selectedDeveloper.ipnUrl,
  //   country: selectedDeveloper.country,
  //   description: selectedDeveloper.description,
  //   sectorId: selectedDeveloper.sectorId,
  //   type: selectedDeveloper.type,
  //   countryPaymentMethods: selectedDeveloper.countryPaymentMethods || [],
  // } : {
  //   logo: "",
  //   businessRegistry: "",
  //   businessName: "",
  //   description: "",
  //   ipnUrl: "",
  //   country: "",
  //   sectorId: "",
  //   type: "COMPANY",
  //   countryPaymentMethods: [],
  // };

  // const formik = useFormik({
  //   initialValues,
  //   validationSchema,
    // onSubmit: async (values) => {
    //   setIsLoadingSubmit(true);
    //   let uploadedLogo = null;
    //   let uploadedRegistry = null;
    //   try {
    //     if (logoFile) {
    //       const res = await uploadImage("logo", logoFile);
    //       values.logo = res?.fileName;
    //       uploadedLogo = res?.fileName;
    //     }
    //     if (registryFile) {
    //       const res = await uploadImage("businessRegistry", registryFile);
    //       values.businessRegistry = res?.fileName;
    //       uploadedRegistry = res?.fileName;
    //     }

    //     const payload = { ...values, merchandId };
    //     if (selectedDeveloper) {
    //       await updateDeveloper(selectedDeveloper.id, payload);
    //       toast.success("Votre business a été modifié avec succès 🎉");
    //     } else {
    //       await addBusiness(payload);
    //       toast.success("Business créé avec succès 🎉");
    //     }

    //     await queryClient.invalidateQueries("developers");
    //     formik.resetForm();
    //     toggle();
    //   } catch (error) {
    //     toast.error("Une erreur est survenue, veuillez réessayer.");
    //     if (uploadedLogo) await deleteMedia(uploadedLogo);
    //     if (uploadedRegistry) await deleteMedia(uploadedRegistry);
    //   } finally {
    //     setIsLoadingSubmit(false);
    //   }
    // },
  // });

  // const next = () => setCurrentStep(currentStep + 1);
  // const prev = () => setCurrentStep(currentStep - 1);

  // const handleUploadLogo = (file) => {
  //   const reader = new FileReader();
  //   reader.onload = (e) => setImageUrl(e.target.result);
  //   reader.readAsDataURL(file);
  //   setLogoFile(file);
  //   return false;
  // };

  // const handleUploadRegistry = (file) => {
  //   setRegistryFile(file);
  //   return false;
  // };

  // const renderBasicInfoForm = () => {
  //   const sectorOptions = (sectors || []).map((s) => ({ value: s.id, label: s.name }));

  //   const handleCreateSector = async (inputValue) => {
  //     const cleanedInput = inputValue.trim().toLowerCase();
  //     const existing = sectorOptions.find(opt => opt.label.toLowerCase() === cleanedInput);
  //     if (existing) return formik.setFieldValue("sector", existing.value);
  //     try {
  //       const newSector = await addSector(inputValue);
  //       if (newSector?.id) {
  //         formik.setFieldValue("sector", newSector.id);
  //         queryClient.invalidateQueries("sectors");
  //       }
  //     } catch (err) {
  //       console.error("Erreur création secteur:", err);
  //     }
  //   };

  //   return (
  //     <Form form={form} layout="vertical">
  //       <h5 className="title-addEdit-Step">Informations basiques</h5>
  //       <Form.Item label="Logo">
  //         <div className="dev-logo-upload-container">
  //           <div className="dev-logo-placeholder">
  //             {imageUrl ? (
  //               <img className="dev-logo-placeholder-img" src={imageUrl} alt="Logo" />
  //             ) : (
  //               <PictureOutlined className="dev-logo-icon" />
  //             )}
  //           </div>
  //           <Upload showUploadList={false} beforeUpload={handleUploadLogo}>
  //             <Button className="upload-btn">
  //               <UploadOutlined /> Uploader
  //             </Button>
  //           </Upload>
  //         </div>
  //       </Form.Item>

  //       <Row>
  //         <FormField label="Business" name="businessName" formik={formik} colSize={6} placeholder="Le nom de votre business" />
  //         <SelectField label="Pays" name="country" nameSelect="le pays d'origine du business" formik={formik} options={countries} error={formik.errors.country} colSize={6} isName={true} />
  //         <CreatableSelectField label="Secteur d’activité" name="sectorId" formik={formik} options={sectorOptions} error={formik.errors.sectorId} colSize={6} isError={isErrorSect} errorApi={errorSect} isLoading={isLoadSect} onCreateOption={handleCreateSector} />
  //         <FormField label="Site internet" name="ipnUrl" formik={formik} colSize={6} placeholder="exemple : www.monbusiness.fr" />
  //         <FormField label="Description" name="description" formik={formik} colSize={12} placeholder="Entrez la description" isTextarea={true} />
  //       </Row>
  //     </Form>
  //   );
  // };

  // const documentForm = () => (
  //   <Form form={form} layout="vertical">
  //     <div className="d-flex justify-content-between align-items-center document-header">
  //       <h5 className="title-addEdit-Step">Documents requis</h5>
  //       <Button className="later-button" onClick={next}>Renseigner plus tard</Button>
  //     </div>
  //     <Row>
  //       <Col lg={1} />
  //       <Col lg={6}>
  //         <div className="upload-box">
  //           <p className="upload-title mt-2">Registre du commerce</p>
  //           <Upload.Dragger
  //             accept=".pdf"
  //             beforeUpload={handleUploadRegistry}
  //             multiple={false}
  //             showUploadList={true}
  //             fileList={registryFile ? [registryFile] : []}
  //             className="mb-2"
  //           >
  //             <div className="upload-content">
  //               <UploadOutlined className="upload-icon" />
  //               <p>Glisser déposer votre fichier</p>
  //               <p className="upload-format">Format requis : PDF</p>
  //               <p>OU</p>
  //               <Button className="upload-button">Importer</Button>
  //               <p className="upload-size">Taille maximum : 5MB</p>
  //             </div>
  //           </Upload.Dragger>
  //         </div>
  //       </Col>
  //       <Col lg={1} />
  //     </Row>
  //   </Form>
  // );

   const modalTitle = selectedDeveloper ? "Édition" : "Création";

  // const validateStep = async () => {
  //   const errors = await formik.validateForm();
  //   if (currentStep === 0) {
  //     const requiredFields = ["businessName", "description", "country", "sector", "ipnUrl"];
  //     const hasErrors = requiredFields.some((field) => errors[field]);
  //     if (hasErrors) return toast.error("Merci de compléter les informations basiques.");
  //   }
  //   if (currentStep === 1 && errors.countryPaymentMethods) {
  //     return toast.error("Merci de sélectionner au moins une méthode de paiement.");
  //   }
  //   setCurrentStep(currentStep + 1);
  // };

  // const steps = [
  //   { title: "Infos basiques", content: renderBasicInfoForm },
  //   { title: "Paiement", content: () => (
  //       <>
  //         <PaymentMethodSelector
  //           paymentList={paymentList}
  //           value={formik.values.countryPaymentMethods}
  //           onChange={(val) => formik.setFieldValue("countryPaymentMethods", val)}
  //         />
  //         {formik.touched.countryPaymentMethods && formik.errors.countryPaymentMethods && (
  //           <div className="text-danger mt-2">{formik.errors.countryPaymentMethods}</div>
  //         )}
  //       </>
  //     )
  //   },
  //   { title: "Documents", content: documentForm },
  //   { title: "Récapitulatif", content: () => <RecapForm formData={formik.values} /> },
  // ];

  return (
    <Modal id="showModalClient" open={modal} onCancel={toggle} footer={null} centered width={900}>
      <h1 className="title-addEdit-Modal mb-5">{modalTitle} d'un nouveau Marchand</h1>
      {/* <Row className="container-steps">
        <Col lg={3} className="sidebar-steps">
          <Steps direction="vertical" current={currentStep}>
            {steps.map((step, index) => (
              <Step key={index} title={step.title} />
            ))}
          </Steps>
        </Col>
        <Col lg={8} className="content-steps">
          {steps[currentStep].content()}
          <div style={{ marginTop: 24 }}>
            {currentStep > 0 && (
              <Button style={{ margin: "0 8px" }} onClick={prev}>Précédent</Button>
            )}
            {currentStep < steps.length - 1 && (
              <Button type="primary" onClick={validateStep}>Suivant</Button>
            )}
            {currentStep === steps.length - 1 && (
              <Button type="primary" onClick={formik.handleSubmit} disabled={isLoadingSubmit}>
                {isLoadingSubmit ? <Spin size="small" /> : "Valider"}
              </Button>
            )}
          </div>
        </Col>
      </Row> */}
    </Modal>
  );
};

export default AddEditDevForm;
